import styled, { css } from 'styled-components';
import { rem } from '../../utils';
const COLLAPSE_BUTTON_WIDTH = 16;
const COLLAPSE_BUTTON_HEIGHT = 88;
export const StyledWrapper = styled.div `
  display: flex;
  width: 100%;
  height: 100%;
  max-width: ${({ theme, visible }) => rem(visible
    ? theme.Components.ToolBar.wrapperSize
    : theme.Components.ToolBar.drawerGap)};
  min-width: ${({ theme, visible }) => rem(visible
    ? theme.Components.ToolBar.wrapperSize
    : theme.Components.ToolBar.drawerGap)};
  z-index: 0;
  /* z-index: ${({ theme }) => theme.ZIndex.ZIndex.Elevated}; */
  position: relative;

  ${({ variant, theme }) => css `
    flex-direction: row;
    gap: ${variant === 'float' && rem(theme.Spacing.Size.XSmall)};
    align-items: ${variant === 'float' ? 'center' : 'inherit'};
    transition: all ${theme.Transition.Timing.Out};
    ${variant === 'float' ? theme.Scrollbar.Panel : theme.Scrollbar.Default}
  `}
`;
export const StyledWrapperComponentTab = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;

  &.menu-component-tab .tabs-wrapper,
  &.menu-component-tab .tabs-content-wrapper {
    height: 100%;
    min-height: 100%;
    position: relative;
  }
`;
export const StyledContentDrawer = styled.div `
  ${({ theme, variant }) => css `
    max-width: ${rem(theme.Components.ToolBar.contentContainer)};
    height: 100%;
    position: relative;
    background-color: ${theme.Components.Panel.Background};
    padding: ${rem(theme.Spacing.Size.Small)} 0;
    border-radius: ${variant === 'float' ? rem(theme.Border.Radius.Large) : 0};
    box-shadow: ${`0 ${rem(1)} ${rem(2)} 0 rgba(0, 0, 0, 0.03)`},
      ${`0 ${rem(1)} ${rem(6)} -${rem(1)} rgba(0, 0, 0, 0.02)`},
      ${`0 ${rem(2)} ${rem(4)} 0 rgba(0, 0, 0, 0.02)`};
    overflow: hidden;
  `}
`;
export const StyledContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  ${({ theme, visible }) => css `
    margin-left: ${rem(theme.Components.ToolBar.navigationGap)};
    transition: transform ${theme.Transition.Timing.Out};
    transform: ${visible ? 'translateX(0%)' : 'translateX(-100%)'};
    padding-left: ${rem(theme.Components.ToolBar.drawerGap)};
  `}
`;
export const StyledContentContainer = styled.div `
  flex-direction: column;
  flex: 1;
  position: relative;
  width: 100%;
  height: 100%;

  ${({ theme, active }) => css `
    display: ${active ? 'flex' : 'none'};
    gap: ${`${rem(theme.Spacing.Size.XSmall)}`};
  `}
`;
export const StyledCollapseButtonContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  /* z-index: 0; */
  opacity: 1;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  filter: drop-shadow(2.5px 0.3px 2px rgba(0, 0, 0, 0.03));
  transition: opacity 0ms;

  ${({ visible, variant }) => css `
    visibility: ${!visible && variant === 'float' ? 'hidden' : 'visible'};
    opacity: ${visible ? 1 : 0};
    width: ${rem(COLLAPSE_BUTTON_WIDTH)};
    height: ${rem(COLLAPSE_BUTTON_HEIGHT)};
    right: 0;
  `}
`;
export const StyledCollapseButtonWrapper = styled.div `
  position: relative;
  display: flex;
  align-items: baseline;

  i,
  svg {
    width: ${rem(COLLAPSE_BUTTON_WIDTH)};
    height: ${rem(COLLAPSE_BUTTON_HEIGHT)};
  }
`;
export const StyledCollapseInnerIcon = styled.span `
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;

  svg {
    opacity: 0.35;
  }

  &:hover svg {
    opacity: 1;
  }
`;
//# sourceMappingURL=ToolBar.style.js.map